import { MakeDashboard } from 'main/factories/modules/Dashboard/dashboard';
import { MakeArchivedGroupsList } from 'main/factories/modules/Groups/archived-groups-list';
import { MakePerformanceSpreadsheetReport } from 'main/factories/modules/PerformanceSpreadsheetReport/performance-spreadsheet-report-factory';
import { MakeStudentsList } from 'main/factories/modules/Persons/Students/students-list-factory';
import { MakeProfessionalReport } from 'main/factories/modules/ProfessionalReport/professional-report';
import { MakeAProfessionalReportDailyWorkload } from 'main/factories/modules/ProfessionalReportDailyWorkload/professional-report-daily-workload-factory';
import { MakeAssistantsList } from 'main/factories/modules/Professionals/Assistants/assistants-list-factory';
import { MakeCoordinatorsList } from 'main/factories/modules/Professionals/Coordinators/coordinators-list-factory';
import { MakePreceptorsList } from 'main/factories/modules/Professionals/Preceptors/preceptors-list-factory';
import { MakeTeachersList } from 'main/factories/modules/Professionals/Teachers/teachers-list-factory';
import { MakePushNotification } from 'main/factories/modules/PushNotification/pushNotification';
import { MakeAcademicOverview } from 'main/factories/modules/Reports/academic-overview';
import { MakeAccessReport } from 'main/factories/modules/Reports/access-report';
import { MakeActivitiesAnalyticalPerGroup } from 'main/factories/modules/Reports/activities-analytical-per-group-factory';
import { MakeActivitiesAnalyticalPerTask } from 'main/factories/modules/Reports/activities-analytical-per-task-factory';
import { MakeActivitiesQuantityPerStudent } from 'main/factories/modules/Reports/activities-quantity-per-student-factory';
import { MakeActivitiesSummarizedByStudent } from 'main/factories/modules/Reports/activities-summarized-by-student';
import { MakeConsolidatedActivitiesByStudent } from 'main/factories/modules/Reports/consolidated-activities-by-student-factory';
import { MakeMissedActivitiesJustifications } from 'main/factories/modules/Reports/missed-activities-justifications';
import { MakeProfessionalsWorkJourney } from 'main/factories/modules/Reports/professionals-work-journey-factory';
import { MakeRejectedByProfessionals } from 'main/factories/modules/Reports/rejected-by-professionals';
import { MakeStudentsFrequencyReport } from 'main/factories/modules/Reports/students-frequency-report';
import { MakeStudentsIndividualWorkloadReport } from 'main/factories/modules/Reports/students-individual-workload-report';
import { MakeStudentsNoAppUsage } from 'main/factories/modules/Reports/students-no-app-usage-factory';
import { MakeStudentsWorkloadAchievement } from 'main/factories/modules/Reports/students-workload-achievement-factory';
import { MakeTeamReport } from 'main/factories/modules/Reports/team-report';
import { useAuth } from 'presentation/app/hooks/useAuth';
import GroupList from 'presentation/app/modules/Groups/pages/group-list';
import { GroupSettings } from 'presentation/app/modules/Groups/pages/group-settings';
import { PendingActivitiesReport } from 'presentation/app/modules/ProfessionalReport/pages/pendingActivities';
import { AuxiliariesList } from 'presentation/app/modules/Professionals/Auxiliaries/pages/auxiliaries-list';
import PreRegistration from 'presentation/app/modules/Professionals/PreRegistration/pages';
import { ProfessionalOverview } from 'presentation/app/modules/Professionals/ProfessionalManagement/pages/professional-overview';
import InternshipLocationActivityReport from 'presentation/app/modules/Reports/pages/activities/analyticals/internship-location-activity-report';
import ReportsAnalyticalActivitiesByStudents from 'presentation/app/modules/Reports/pages/activities/analyticals/reports-analytical-activities-by-students';
import ActivitiesSummaryByTask from 'presentation/app/modules/Reports/pages/activities/summarized/activities-summary-by-task';
import SummaryReportByGroup from 'presentation/app/modules/Reports/pages/activities/summarized/summary-report-by-group';
import SummaryReportByInternshipLocation from 'presentation/app/modules/Reports/pages/activities/summarized/summary-report-by-internship-location';
import { SuspectedLocationManipulation } from 'presentation/app/modules/Reports/pages/activities/suspected-location-manipulation';
import ValidatedByProfessionals from 'presentation/app/modules/Reports/pages/activities/validated-by-professionals';
import { PageNumberStudentsPerProfessionalInTheField } from 'presentation/app/modules/Reports/pages/professionals/number-students-per-professional-in-the-field';
import { PerformanceReportForProfessionals } from 'presentation/app/modules/Reports/pages/professionals/performance-report-for-professionals';
import { AppRegisteredStudentsPerGroup } from 'presentation/app/modules/Reports/pages/students/app-registered-students-per-group';
import StudentReportDailyWorkload from 'presentation/app/modules/Reports/pages/students/student-report-daily-workload';
import StudentsWithoutRegisteringApp from 'presentation/app/modules/Reports/pages/students/students-without-registering-app';
import { TceSummary } from 'presentation/app/modules/TceSummary/pages';
import { TceManagementList } from 'presentation/app/modules/TceSummary/pages/tce-management-list';
import { UsersOnline } from 'presentation/app/modules/UsersOnline/pages';
import { Navigate } from 'react-router-dom';

export const PrivateRoutes = (props: any) => {
  const { currentUser } = useAuth();
  if (!currentUser) {
    return <Navigate to={{ pathname: '/login' }} />;
  }

  return <>{props.children}</>;
};

const privateRoutes = [
  {
    path: '/dashboard',
    exact: true,
    component: <MakeDashboard />,
  },
  {
    path: '/equipe/professores',
    exact: true,
    component: <MakeTeachersList />,
  },
  {
    path: '/equipe/preceptores',
    exact: true,
    component: <MakePreceptorsList />,
  },

  {
    path: '/equipe/assistentes',
    exact: true,
    component: <MakeAssistantsList />,
  },

  {
    path: '/equipe/coordenadores',
    exact: true,
    component: <MakeCoordinatorsList />,
  },

  {
    path: '/equipe/auxiliares',
    exact: true,
    component: <AuxiliariesList />,
  },
  {
    path: '/estudantes',
    exact: true,
    component: <MakeStudentsList />,
  },

  {
    path: '/relatorios/gestao-academica/visao-geral',
    exact: true,
    component: <MakeAcademicOverview />,
  },
  {
    path: '/relatorios/acessos',
    exact: true,
    component: <MakeAccessReport />,
  },
  {
    path: '/relatorios/profissionais/equipe',
    exact: true,
    component: <MakeTeamReport />,
  },
  {
    path: '/relatorios/atividades/consolidada-por-estudante',
    exact: true,
    component: <MakeConsolidatedActivitiesByStudent />,
  },
  {
    path: 'relatorios/profissionais/planilha-desempenho',
    exact: true,
    component: <MakePerformanceSpreadsheetReport />,
  },
  //
  {
    path: '/relatorios/atividades/local-estagio-analitico',
    component: <InternshipLocationActivityReport />,
  },

  {
    path: '/relatorios/atividades/analitico-por-grupo',
    exact: true,
    component: <MakeActivitiesAnalyticalPerGroup />,
  },
  {
    path: '/relatorios/atividades/analitico-por-estudante',
    exact: true,
    component: <ReportsAnalyticalActivitiesByStudents />,
  },
  {
    path: '/relatorios/atividades/analitico-por-tarefa',
    exact: true,
    component: <MakeActivitiesAnalyticalPerTask />,
  },
  {
    path: '/relatorios/profissionais/jornada-de-trabalho',
    exact: true,
    component: <MakeProfessionalsWorkJourney />,
  },
  {
    path: '/relatorios/profissionais/carga-horaria-diaria',
    exact: true,
    component: <MakeAProfessionalReportDailyWorkload />,
  },
  {
    path: '/relatorios/profissionais/desempenho',
    exact: true,
    component: <MakeProfessionalReport />,
  },
  {
    path: '/relatorios/estudantes/frequencia',
    exact: true,
    component: <MakeStudentsFrequencyReport />,
  },
  {
    path: '/relatorios/estudantes/carga-horaria-individual',
    exact: true,
    component: <MakeStudentsIndividualWorkloadReport />,
  },
  {
    path: '/relatorios/estudantes/carga-horaria-alcancada',
    exact: true,
    component: <MakeStudentsWorkloadAchievement />,
  },
  {
    path: '/relatorios/atividades/quantitativo-por-estudante',
    exact: true,
    component: <MakeActivitiesQuantityPerStudent />,
  },
  {
    path: '*',
    component: <Navigate to="/dashboard" />,
  },
  {
    path: '/relatorios/estudantes/carga-horaria-diaria',
    exact: true,
    component: <StudentReportDailyWorkload />,
  },
  {
    path: '/grupos',
    exact: true,
    component: <GroupList />,
  },
  {
    path: '/grupos/configurar/:id',
    exact: true,
    component: <GroupSettings />,
  },
  {
    path: '/grupos-arquivados',
    exact: true,
    component: <MakeArchivedGroupsList />,
  },
  {
    path: '/relatorios/atividades/resumido-por-estudante',
    exact: true,
    component: <MakeActivitiesSummarizedByStudent />,
  },
  {
    path: '/relatorios/atividades/resumido-por-grupo',
    exact: true,
    component: <SummaryReportByGroup />,
  },
  {
    path: '/relatorios/atividades/resumido-por-tarefa',
    exact: true,
    component: <ActivitiesSummaryByTask />,
  },
  {
    path: '/relatorios/atividades/resumido-por-local-estagio',
    exact: true,
    component: <SummaryReportByInternshipLocation />,
  },
  {
    path: '/relatorios/estudantes/sem-cadastro-app',
    exact: true,
    component: <StudentsWithoutRegisteringApp />,
  },
  {
    path: '/relatorios/estudantes/sem-utilizacao-app',
    exact: true,
    component: <MakeStudentsNoAppUsage />,
  },
  {
    path: '/relatorios/atividades/validadas-por-profissionais',
    exact: true,
    component: <ValidatedByProfessionals />,
  },
  {
    path: '/relatorios/atividades/rejeitadas-por-profissionais',
    exact: true,
    component: <MakeRejectedByProfessionals />,
  },
  {
    path: '/relatorios/atividades/justificativas-de-atividades-perdidas',
    exact: true,
    component: <MakeMissedActivitiesJustifications />,
  },
  {
    path: '/relatorios/atividades/indicios-manipulacao-localizacao',
    exact: true,
    component: <SuspectedLocationManipulation />,
  },
  {
    path: '/relatorios/estudantes/cadastrados-app-por-grupo',
    exact: true,
    component: <AppRegisteredStudentsPerGroup />,
  },
  { path: '*', component: <Navigate to="/dashboard" /> },
  {
    path: '/pre-cadastro/:professionalType',
    exact: true,
    component: <PreRegistration />,
  },
  {
    path: '/gerenciamento-de-profissional/:professionalType/:id',
    exact: true,
    component: <ProfessionalOverview />,
  },
  /* {
    path: '/gerenciamento-de-profissional/:professionalType/novo',
    exact: true,
    component: <ProfessionalManagementForm />,
  }, */

  {
    path: '/relatorios/profissionais/atividades-pendentes',
    exact: true,
    component: <PendingActivitiesReport />,
  },

  {
    path: '/usuarios-online',
    exact: true,
    component: <UsersOnline />,
  },
  {
    path: '/ferramentas/push-notification',
    exact: true,
    component: <MakePushNotification />,
  },

  {
    path: '/tce',
    exact: true,
    component: <TceSummary />,
  },
  {
    path: '/tce/listagem',
    exact: true,
    component: <TceManagementList />,
  },

  {
    path: '/relatorios/profissionais/quantidade-estudantes-em-campo',
    exact: true,
    component: <PageNumberStudentsPerProfessionalInTheField />,
  },

  {
    path: '/desempenho-dos-profissionais',
    exact: true,
    component: <PerformanceReportForProfessionals />,
  },
];

export { privateRoutes };
